const prefix = 'USER';

const ADD = `${prefix}/ADD`;
const CLEAR = `${prefix}/CLEAR`;

export {
  ADD,
  CLEAR,
};
